import { render, staticRenderFns } from "./GoodDetail.vue?vue&type=template&id=03664212&scoped=true"
import script from "./GoodDetail.vue?vue&type=script&lang=js"
export * from "./GoodDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodDetail.vue?vue&type=style&index=0&id=03664212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03664212",
  null
  
)

export default component.exports